var _path, _path2, _path3, _path4, _path5, _path6;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) { ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgCarActionsCheck = function SvgCarActionsCheck(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M23.164 10.466C23.0148 9.79293 22.6765 9.17644 22.189 8.689L20.25 6.75H3.75L1.811 8.689C1.13191 9.36832 0.750294 10.2895 0.75 11.25C0.75 11.6478 0.908035 12.0294 1.18934 12.3107C1.47064 12.592 1.85218 12.75 2.25 12.75H9.75",
    stroke: "#000033",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M1.07495 9.75H5.24995",
    stroke: "#000033",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M3.75 6.75L5.45 2.21C5.61083 1.7807 5.89902 1.4108 6.27595 1.14986C6.65288 0.888918 7.10056 0.749402 7.559 0.750002H16.441C16.8989 0.750014 17.3459 0.889814 17.7223 1.15071C18.0986 1.41161 18.3863 1.78118 18.547 2.21L20.247 6.75H3.75Z",
    stroke: "#000033",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M2.25 12.75V14.25C2.25 14.6478 2.40804 15.0294 2.68934 15.3107C2.97064 15.592 3.35218 15.75 3.75 15.75C4.14782 15.75 4.52936 15.592 4.81066 15.3107C5.09196 15.0294 5.25 14.6478 5.25 14.25V12.75H2.25Z",
    stroke: "#000033",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M17.25 23.25C20.5637 23.25 23.25 20.5637 23.25 17.25C23.25 13.9363 20.5637 11.25 17.25 11.25C13.9363 11.25 11.25 13.9363 11.25 17.25C11.25 20.5637 13.9363 23.25 17.25 23.25Z",
    stroke: "#000033",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M19.9239 15.506L17.0189 19.379C16.9543 19.4648 16.8721 19.5358 16.7777 19.5872C16.6833 19.6386 16.579 19.6691 16.4719 19.6768C16.3647 19.6845 16.2571 19.6691 16.1564 19.6317C16.0557 19.5943 15.9641 19.5358 15.8879 19.46L14.3879 17.96",
    stroke: "#000033",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
};
export default SvgCarActionsCheck;